import { Box, HStack, Text } from '@chakra-ui/react';
import { CheckMarkIcon } from 'assets/icons/v2';
import { VoucherFilterOptionProps } from '../types/FilterOption';

export const OptionWithCheckmark = ({
  label,
  onClick,
  isActive = false,
}: VoucherFilterOptionProps): React.ReactElement => {
  return (
    <Box padding="15px" cursor="pointer" _hover={{ bg: 'background.canvas' }} onClick={onClick}>
      <HStack justify="flex-start" align="center">
        <Box boxSize="24px">{isActive && <CheckMarkIcon color="icon.accent" boxSize="16px" />}</Box>

        <Text textStyle="body.s.medium" color="text.primary">
          {label}
        </Text>
      </HStack>
    </Box>
  );
};
